import { callApi } from '@/api/http'

export const getQuestionnaire = (payload) => {
  return callApi('post', 'questionnaire/info', payload)
}
export const getQuestionnaireList = (payload) => {
  return callApi('post', 'questionnaire/list', payload)
}

export const fillQuestionnaire = (payload) => {
  return callApi('post', 'questionnaire/fill-in', payload)
}
export const getFillList = (payload) => {
  return callApi('post', 'questionnaire/fill-in-list', payload)
}
export const getFillInfo = (payload) => {
  return callApi('post', 'questionnaire/fill-in-info', payload)
}

export const setContactInfo = (payload) => {
  return callApi('post', 'questionnaire/form', payload)
}

export const uploadFile = (payload) => {
  return callApi('post', 'questionnaire/upload-file', payload)
}
export const confirm = (payload) => {
  return callApi('post', 'questionnaire/confirm', payload)
}
